import endpoints from '../endpoints/email-connect';

function multiEmailLogin(email, password, spotId = undefined) {
  var payload = { email, password };
  if (spotId) {
    payload.spot_id = spotId;
  }
  return endpoints.multiEmailLogin.execute(payload);
}

export default {
  multiEmailLogin
};
